module.exports = __webpack_public_path__ + "img/graph-paper-notebook_B099NJT3NR.be0f4f35.jpg";